import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { cn } from '@/lib/utils';
import { Checkbox } from '../ui/checkbox';

interface CheckboxProps {
  name: string;
  label?: string | null;
  className?: string;
  labelClass?: string;
  control: any;
  description?: string;
  required?: boolean;
  disabled?: boolean;
  notRequired?: boolean;
  withoutDescription?: boolean;
}

export default function CheckboxControl({
  name,
  label,
  control,
  description,
  className,
  labelClass,
  required,
  disabled,
  notRequired,
  withoutDescription,
}: CheckboxProps) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn(className, 'relative')}>
          <div className="flex items-center gap-2">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={disabled}
              />
            </FormControl>
            {label && (
              <FormLabel
                className={cn(labelClass, 'font-normal text-sm cursor-pointer')}
              >
                {label} {required && <span className={cn('text-red')}>*</span>}
              </FormLabel>
            )}
          </div>
          {withoutDescription ? null : (
            <div className="absolute -bottom-[18px] right-0">
              {description && <FormDescription>{description}</FormDescription>}
              {!notRequired && <FormMessage />}
            </div>
          )}
        </FormItem>
      )}
    />
  );
}
